import { useRecoilValue } from 'recoil';

import * as K from 'common/constants';
import { searchParamState } from 'components/common/Managers/RouteStateManager.state';

import ConfigurationFilePage from './ConfigurationFilePage';

/**
 * Routing component for configuration file pages. This component returns a page to edit the appropriate configuration
 * file based on the "path" parameter.
 */
function FileRouter(): JSX.Element {

  const path = useRecoilValue(searchParamState(K.URL_PARAM.PATH));

  return (
    <ConfigurationFilePage
      key={path}
      path={path}
    />
  );

}

export default FileRouter;
